<template>
    <app-modal
        :modal-id="modalId"
        :title="modalTitle"
        :preloader="preloader"
        @submit="submit"
        @close-modal="closeModal"
        modal-size="large"
    >
        <template slot="header">
            <h5 class="modal-title">{{ modalTitle }}</h5>
            <button type="button" class="close outline-none" @click.prevent="closeModal">
                <span><app-icon :name="'x'" /></span>
            </button>
        </template>

        <template slot="body">
            <app-overlay-loader v-if="preloader" />
            <form
                ref="form"
                class="mb-0"
                :class="{ 'loading-opacity': preloader }"
                :data-url="selectedUrl ? `sites/${inputs.id}` : `sites`"
            >
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="site-name">{{ $t('name') }}</label>
                            <app-input id="site-name" v-model="inputs.name" type="text" :required="true" />
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="site-description">{{ $t('description') }}</label>
                            <app-input id="site-description" v-model="inputs.description" type="text" :required="true" />
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="site-latitude">{{ $t('latitude') }}</label>
                            <app-input id="site-latitude" v-model="inputs.latitude" type="decimal" />
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="site-longitude">{{ $t('longitude') }}</label>
                            <app-input id="site-longitude" v-model="inputs.longitude" type="decimal" />
                        </div>
                    </div>
                    <div class="col-12">
                        <p class="text-muted mb-0">{{ $t('coordinates_recommended_for_eta') }}</p>
                    </div>
                </div>
            </form>
        </template>

        <template slot="footer">
            <button type="button" class="btn btn-secondary mr-4" data-dismiss="modal" @click="closeModal">
                {{ $t('cancel') }}
            </button>
            <button type="button" class="btn btn-primary" @click="submit">
                {{ $t('save') }}
            </button>
        </template>
    </app-modal>
</template>

<script>
import { FormMixin } from '../../../../core/mixins/form/FormMixin';
import { ModalMixin } from '../../../Mixins/ModalMixin';

export default {
    name: 'SiteAddEditModal',
    mixins: [FormMixin, ModalMixin],
    props: {
        tableId: {
            type: String,
            default: 'sites-table',
        },
    },
    data() {
        return {
            modalId: 'site-add-edit-modal',
            modalTitle: this.$t('new_site'),
            inputs: {
                name: '',
                description: '',
                latitude: '',
                longitude: '',
            },
        };
    },
    methods: {
        submit() {
            this.save(this.inputs);
        },
        afterSuccess(response) {
            this.$toastr.s(response.data.message);
            this.$hub.$emit('reload-' + this.tableId);
            this.$store.dispatch('getSites');
        },
        afterSuccessFromGetEditData(response) {
            this.inputs = {
                ...response.data,
                latitude: response.data.latitude ?? response.data.lat ?? '',
                longitude: response.data.longitude ?? response.data.lng ?? '',
            };
            this.preloader = false;
        },
    },
    created() {
        if (this.selectedUrl) {
            this.modalTitle = this.$t('edit');
            this.preloader = true;
        }
    },
}
</script>
